import { IconButton, IconButtonProps } from '@mui/material';
import { IconRotateClockwise2 } from '@tabler/icons-react';
import { DS } from './ds';

interface ActivateButtonProps extends Omit<IconButtonProps, 'children'> {
  iconSize?: number;
}

const ActivateButton = ({ iconSize = 18, sx, ...rest }: ActivateButtonProps) => (
  <IconButton
    size="small"
    title="Activar"
    sx={{ color: DS.green, '&:hover': { bgcolor: '#d1fae5' }, ...sx }}
    {...rest}
  >
    <IconRotateClockwise2 size={iconSize} />
  </IconButton>
);

export default ActivateButton;
